import type React from 'react';

import { useInboxActions } from '../../../../hooks/settings/inboxes/useInboxActions';
import InboxDataModal from './InboxDataModal';

export const CreateInboxModal: React.FC = () => {
  const { createInbox } = useInboxActions();

  return <InboxDataModal onSubmit={createInbox} />;
};

export default CreateInboxModal;
